import {
  FETCH_APIKEYS,
  FETCH_APIKEY,
  CREATE_APIKEY,
  UPDATE_APIKEY,
  DEACTIVATE_APIKEY,
  DELETE_APIKEY,
  APIKEY_ERROR,
  CLEAR_APIKEY_ERROR
} from "./types";

const initialState = {
  apiKeys: [],
  selectedApiKey: null,
  error: null,
  loading: false
};

export default function apiKeysReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_APIKEYS:
      return {
        ...state,
        apiKeys: action.payload,
        error: null,
        loading: false
      };

    case FETCH_APIKEY:
      return {
        ...state,
        selectedApiKey: action.payload,
        error: null,
        loading: false
      };

    case CREATE_APIKEY:
      return {
        ...state,
        apiKeys: [action.payload, ...state.apiKeys],
        error: null
      };

    case UPDATE_APIKEY:
    case DEACTIVATE_APIKEY:
      return {
        ...state,
        apiKeys: state.apiKeys.map(key => 
          key._id === action.payload._id ? action.payload : key
        ),
        selectedApiKey: state.selectedApiKey?._id === action.payload._id ? action.payload : state.selectedApiKey,
        error: null
      };

    case DELETE_APIKEY:
      return {
        ...state,
        apiKeys: state.apiKeys.filter(key => key._id !== action.payload),
        selectedApiKey: state.selectedApiKey?._id === action.payload ? null : state.selectedApiKey,
        error: null
      };

    case APIKEY_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false
      };

    case CLEAR_APIKEY_ERROR:
      return {
        ...state,
        error: null
      };

    default:
      return state;
  }
}